export function getServisKaydiBaglantiLabel(servisKaydiDurum) {
  const d = String(servisKaydiDurum || '').trim();
  if (!d) return null;
  if (d === 'Taslak') return 'Kayıt açık (taslak)';
  if (['Tamamlandı', 'Randevu Tamamlandı', 'Çözüldü', 'Randevu İptal Edildi'].includes(d)) {
    return 'Servis kaydı tamamlandı';
  }
  return 'Servis kaydı açılmış';
}

export const DURUM_LABELS = {
  bekliyor: 'Bekliyor',
  arandi: 'Arandı',
  tamamlandi: 'Tamamlandı',
  iptal: 'İptal',
};

export const DURUM_BADGE = {
  bekliyor: { bg: '#dbeafe', color: '#1d4ed8' },
  arandi: { bg: '#fef3c7', color: '#b45309' },
  tamamlandi: { bg: '#d1fae5', color: '#047857' },
  iptal: { bg: '#f1f5f9', color: '#64748b' },
};
